// This must be the first line in src/index.js
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import authentication from './utils/auth/react-azure-adb2c';
import { AUTH } from './utils/auth/authConstants';
import config from './utils/constants/config';

authentication.initialize(
    {
        // optional, will default to this
        instance: config.AUTH_TENANT_INSTANCE,
        // your B2C tenant
        tenant: config.AUTH_TENANT_NAME,
        // the policy to use to sign in, can also be a sign up or sign in policy
        signInPolicy: 'B2C_1_PolicyHolders_SignUpAndSignIn',
        // the policy to use for password reset
        resetPolicy: 'B2C_1_PolicyHolders_ResetPassword',
        // the policy to use to edit the profile
        profilePolicy: 'B2C_1_PolicyHolders_EditProfile',
        // the the B2C application you want to authenticate with
        clientId: config.AUTH_CLIENT_ID,
        // where MSAL will store state - localStorage or sessionStorage
        cacheLocation: 'sessionStorage',
        // the scopes you want included in the access token
        scopes: [
            config.AUTH_CLIENT_AUDIENCE_URI + '/api_access',
            config.AUTH_CLIENT_AUDIENCE_URI + '/user_impersonation',
        ],
        // optional, the redirect URI - if not specified MSAL will pick up the location from window.href
        redirectUri: config.AUTH_REDIRECT_URI,
        // optional, the URI to redirect to after logout
        postLogoutRedirectUri: config.AUTH_REDIRECT_URI,
    },
    AUTH.policyTypes.signIn.key,
);

authentication.run(() => {
    ReactDOM.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
        document.getElementById('root'),
    );
    // registerServiceWorker();
});
